import React, { useEffect, useState } from "react";
import { startLoader, stopLoader } from "../../../lib/utils";
import Toast from "../../../lib/toast";
import { getAllParameters } from "../../../features/parameters/helper/api";
import { isAuthenticated } from "../../../auth";
import Status from "./status";

const ContentFilter = (props) => {

  const {user, token} = isAuthenticated();
  const [currentElementId, setCurrentElementId] = useState("");
  const [contentPrivacy, setContentPrivacy] = useState("All");
  const [contentRole, setContentRole] = useState("All");
  const [contentType, setContentType] = useState("All");
  const [isContentRoleListOpen, setContentRoleListOpen] = useState(false);
  const [isContentPrivacyListOpen, setContentPrivacyListOpen] = useState(false);
  const [isContentTypeListOpen, setContentTypeListOpen] = useState(false);
  const [Parameters, setParameters] = useState({
    exerciseType: [],
    exerciseLevel: [],
    targetMuscle: []
  });

  const [selectedParameters, setSelectedParameters] = useState({
    exerciseType: [],
    exerciseLevel: [],
    targetMuscle: []
  });

  const [tempIDs, setTempIDs] = useState([]);

  const [contentFilters, setContentFilters] = useState({
    status: true,
    contentType: "All",
    contentRole: "All",
  });
  
  
  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = document.getElementById(id) ? document.getElementById(id) : event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }

    if(id == "content-privacy"){
      setContentPrivacyListOpen(!isContentPrivacyListOpen)
    }

    if(id == "content-role"){
      setContentRoleListOpen(!isContentRoleListOpen)
    }

    if(id == "content-type"){
      setContentTypeListOpen(!isContentTypeListOpen)
    }

  }

  const getSelectedContentType = (value) => {
    setContentType(value);

    setContentFilters(oldData => ({
      ...oldData,
      contentType: value
    }))
  }

  const getSelectedContentPrivacy = (value) => {
    setContentPrivacy(value);
    if(value === "All"){
      props.contentPrivacy("");
    }
    if(value === "Private"){
      props.contentPrivacy("private");
    }
    if(value === "Public"){
      props.contentPrivacy("public");
    }

  }

  const getSelectedContentRole = (value) => {
    setContentRole(value);

    if(!props.setDbFilter){
      if(value == "All"){
        props.contentRole("All");
      }
      if(value == "My Content"){
        props.contentRole("my");
      }
      if(value == "Branch Content"){
        props.contentRole("branch");
      }
      if(value == "Workout Plus Content"){
        props.contentRole("instafit");
      }
    }

    setContentFilters(oldData => ({
      ...oldData,
      contentRole: value
    }))
  }

  const GetParameters = async type => {
    try {
      let params = {
        noLimit: 'noLimit',
        sortByInstafit: "sort",
        type
      }
      let response = await getAllParameters(user._id, token, params);
      if (!response.error) {
        return response;
      } else {
        new Toast({
          message:response.error,
          duration:3000,
          type:'error'
        })
        return [];
        }
    } catch (error) {
        // do something
    }
  }

  const handleTempIDs = (id, type) => event => {
    let ids = [...tempIDs];
    let index = ids.findIndex(d => d == id);

    if (index == -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    setTempIDs(ids);

    setSelectedParameters((prev) => {
      const updated = { ...prev };

      Object.keys(updated).forEach((key) => {
        updated[key] = updated[key].filter((item) => item !== id);
      });

      const currentList = [...(prev[type] || [])];

      if (!prev[type].includes(id)) {
        updated[type].push(id);
      }

     
      props.setParameterFilter(updated);
     

      return updated;
    });

    // setSelectedParameters((prev) => {
    //   const updated = { ...prev };

    //   let currentList = [...(prev[type] || [])];

    //   const isAlreadySelected = currentList.some((item) => item._id === id);

    //   if (isAlreadySelected) {
    //     currentList = currentList.filter((item) => item._id !== id);
    //   } else {
    //     const foundObj = Parameters[type]?.find((item) => item._id === id);

    //     if (foundObj) {
    //       currentList.push(foundObj);
    //     }
    //   }

    //   updated[type] = currentList;

    //   props.setParameterFilter(updated);

    //   return updated;
    // });
  }
  useEffect(() => {
  if (props.isReset) {
   
    setContentPrivacy("All");
    setContentRole("All");
    setContentType("All");
    setTempIDs([]);
    setSelectedParameters({
      exerciseType: [],
      exerciseLevel: [],
      targetMuscle: []
    });
    setContentFilters({
      status: true,
      contentType: "All",
      contentRole: "All",
    });

    
    if (props.setParameterFilter) {
      props.setParameterFilter({
        exerciseType: [],
        exerciseLevel: [],
        targetMuscle: []
      });
    }

    
    if (props.handleResetState) {
      props.handleResetState();
    }
  }
  }, [props.isReset]);
  const getStatus = (value) => {
    setContentFilters(oldData => ({
      ...oldData,
      status: value
    }))
  }  

  useEffect(()=>{
    if(props.setDbFilter){
      props.contentFilters(contentFilters);
    } 
  },[contentFilters]);

  useEffect(() => {
    if(props.setDbFilter == false){
      // setContentRole("Workout Plus Content");
      // props.contentRole("instafit");
      setContentRole("All");
      props.contentRole("All");
    }
  },[user.role == 5])

  useEffect(() => {
    if(user.role == 0 && props.setDbFilter == false){
      setContentRole("All");
      props.contentRole("All");
    }
  },[user.role == 0])


  useEffect(async() => {
    try {
      await startLoader();
      let exerciseLevel = await GetParameters("exerciseLevel");
      let exerciseType = await GetParameters("exerciseType");
      let targetMuscle = await GetParameters("targetMuscle");

      setParameters({
        ...Parameters,
        exerciseLevel,
        exerciseType,
        targetMuscle
      })
      await stopLoader();
    } catch (error) {
      await stopLoader();
    }
  },[])

  return(
    <div className="w-full">
      {
        props.setDbFilter ? (
          <div className="w-full m-b-20">
            <Status getStatus={getStatus} />
          </div>
        ) : (
          <p className="fs-16 m-b-10 font-weight-700 color-black">Content Filter</p>
        )
      }

      <div className="d-flex space-between">
        {
          props.setDbFilter ? (    
            <div onClick={toggleInputFields('content-type')} className={`${(currentElementId == "content-type" || contentType) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "content-type" || contentType) ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "content-type" || contentType) ? "10px" : "14px", color: (currentElementId == "content-type" || contentType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Content Type</p>
              <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                <svg className="flex-item" style={{ transform: isContentPrivacyListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                </svg>
              </div>
              <input className={`${(currentElementId == "content-type" || contentType) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gym Type" value={contentType} style={{ pointerEvents: "none",textTransform:'capitalize' }} />
              {
                isContentTypeListOpen && (
                  <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                    <div onClick={()=>getSelectedContentType("All")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">All</p>
                    </div>
                    <div onClick={()=>getSelectedContentType("Main Exercise")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">Main Exercise</p>
                    </div>
                    <div onClick={()=>getSelectedContentType("Warm Up")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">Warm Up</p>
                    </div>
                    <div onClick={()=>getSelectedContentType("Cool Down")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">Cool Down</p>
                    </div>
                    <div onClick={()=>getSelectedContentType("Fitness")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">Fitness</p>
                    </div>
                  </div>
                )
              } 
            </div>
          ) : (
            <div onClick={toggleInputFields('content-privacy')} className={`${(currentElementId == "content-privacy" || contentPrivacy) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "content-privacy" || contentPrivacy) ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "content-privacy" || contentPrivacy) ? "10px" : "14px", color: (currentElementId == "content-privacy" || contentPrivacy) ? "var(--darkBlue)" : "", transition: "180ms" }}>Content Privacy</p>
              <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                <svg className="flex-item" style={{ transform: isContentPrivacyListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                </svg>
              </div>
              <input className={`${(currentElementId == "content-privacy" || contentPrivacy) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gym Type" value={contentPrivacy} style={{ pointerEvents: "none",textTransform:'capitalize' }} />
              {
                isContentPrivacyListOpen && (
                  <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                    <div onClick={()=>getSelectedContentPrivacy("All")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">All</p>
                    </div>
                    <div onClick={()=>getSelectedContentPrivacy("Private")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">Private</p>
                    </div>
                    <div onClick={()=>getSelectedContentPrivacy("Public")} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">Public</p>
                    </div>
                  </div>
                )
              }
            </div>
          )
        }
        <div onClick={toggleInputFields('content-role')} className={`${(currentElementId == "content-role" || contentRole) ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "content-role" || contentRole) ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "content-role" || contentRole) ? "10px" : "14px", color: (currentElementId == "content-role" || contentRole) ? "var(--darkBlue)" : "", transition: "180ms" }}>Content Role</p>
          <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
            <svg className="flex-item" style={{ transform: isContentRoleListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
            </svg>
          </div>
          <input className={`${(currentElementId == "content-role" || contentRole) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gym Type" value={contentRole} style={{ pointerEvents: "none",textTransform:'capitalize' }} />
          {/* Dropdown Container */}
          {
            isContentRoleListOpen && (
              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                <div onClick={()=>getSelectedContentRole("All")} className="global-input-field-arrow-dropdown-item">
                  <p className="flex-item">All</p>
                </div>
                <div onClick={()=>getSelectedContentRole("Branch Content")} className="global-input-field-arrow-dropdown-item">
                  <p className="flex-item">Branch Content</p>
                </div>
                <div onClick={()=>getSelectedContentRole("Workout Plus Content")} className="global-input-field-arrow-dropdown-item">
                  <p className="flex-item">Workout Plus Content</p>
                </div>
                <div onClick={()=>getSelectedContentRole("My Content")} className="global-input-field-arrow-dropdown-item">
                  <p className="flex-item">My Content</p>
                </div>
              </div>
            )
          }
        </div>
      </div>

      <div className="chips-filter-container m-b-12">
        <div className="d-flex m-b-8">
          <p className="flex-item fs-16 font-weight-700 color-dark-blue margin-auto m-t-6">Exercise Type</p>
        </div>
        <div className="chips-scroll-container d-flex-wrap">
          {
            Parameters.exerciseType.map(data => {
              return(
                <div onClick={handleTempIDs(data._id, "exerciseType")} className="d-flex chips-filter-item m-r-12 m-b-12" style={{backgroundColor: tempIDs.findIndex(id => id == data._id) != -1 && "#E33A34"}}>
                  <p className="flex-item fs-12" style={{color: tempIDs.findIndex(id => id == data._id) != -1 && "#ffffff"}}>{data.name}</p>
                </div>
              )
            })
          }
        </div>
      </div>

      <div className="chips-filter-container m-b-12">
        <div className="d-flex m-b-8">
          <p className="flex-item fs-16 font-weight-700 color-dark-blue margin-auto m-t-6">Exercise Level</p>
        </div>
        <div className="chips-scroll-container d-flex-wrap">
          {
            Parameters.exerciseLevel.map(data => {
              return(
                <div onClick={handleTempIDs(data._id, "exerciseLevel")} className="d-flex chips-filter-item m-r-12 m-b-12" style={{backgroundColor: tempIDs.findIndex(id => id == data._id) != -1 && "#E33A34"}}>
                  <p className="flex-item fs-12" style={{color: tempIDs.findIndex(id => id == data._id) != -1 && "#ffffff"}}>{data.name}</p>
                </div>
              )
            })
          }
        </div>
      </div>

      <div className="chips-filter-container m-b-12">
        <div className="d-flex m-b-8">
          <p className="flex-item fs-16 font-weight-700 color-dark-blue margin-auto m-t-6">Target Muscle</p>
        </div>
        <div className="chips-scroll-container d-flex-wrap">
          {
            Parameters.targetMuscle.map(data => {
              return(
                <div onClick={handleTempIDs(data._id, "targetMuscle")} className="d-flex chips-filter-item m-r-12 m-b-12" style={{backgroundColor: tempIDs.findIndex(id => id == data._id) != -1 && "#E33A34"}}>
                  <p className="flex-item fs-12" style={{color: tempIDs.findIndex(id => id == data._id) != -1 && "#ffffff"}}>{data.name}</p>
                </div>
              )
            })
          }
        </div>
      </div>

    </div>
  )
}

export default ContentFilter;